import styled from 'styled-components';

export const Container = styled.footer`
  min-height: 49px;
  width: calc(100vw - 237px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 237px;

  font: normal normal normal 12px/15px Source Sans Pro;
  background-color: var(--color-white);
  color: var(--color-gray-100);
`;
